var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"value":true,"permanent":""}},[_c('v-list',{staticClass:"py-4",attrs:{"dense":"","nav":""}},_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item.title,attrs:{"link":"","to":item.to}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.title))])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }